<script setup>
import CsaCarousel from "@/components/CsaCarousel.vue";
import CsaService from "@/views/home/CsaService.vue";
import CsaLocation from "@/views/about/CsaLocation.vue";
import WhyUs from "@/views/about/WhyUs.vue";
import {getCurrentInstance, onMounted, reactive} from "vue";
const { $axios } = getCurrentInstance().appContext.config.globalProperties;
const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
const homepageData = reactive({});

onMounted(()=>{
  $axios.get($endpoint.LoadHomePage).then((resp_homepage_data)=>{
    Object.assign(homepageData, resp_homepage_data.data);
  })
})
</script>
<template>
  <div>
    <csa-carousel v-if="homepageData && homepageData.heroSliders" :carousel-items="homepageData?.heroSliders"></csa-carousel>
    <csa-service v-if="homepageData && homepageData.services" :service-item-list="homepageData?.services"></csa-service>
    <why-us  v-if="homepageData && homepageData.abouts" :about-bloc="homepageData?.abouts" :about-title="homepageData?.aboutTitle"></why-us>
    <csa-location v-if="homepageData && homepageData.contactInfos" :location-infos="homepageData?.contactInfos??{}"></csa-location>
  </div>
</template>
<style scoped>

</style>